import type { TFeatureName } from './featureFlagsModels';

import { FeatureFlagsBase, getPromiseWith, EFeatureValue } from './featureFlagsModels';
import { ToolbarStorage } from '../dev-toolbar';
import { isProdBuildMode } from '#shared/helpers/buildMode';

export const FeatureFlags = new Proxy(FeatureFlagsBase, {
  get(target, name: TFeatureName) {
    if (isProdBuildMode()) {
      return target[name];
    }

    // @ts-ignore
    const toolbarStorageValue: EFeatureValue =
      ToolbarStorage.getStorageToolbarField('featureFlags')?.[name];

    switch (toolbarStorageValue) {
      case EFeatureValue.ENABLED:
        return getPromiseWith(true);
      case EFeatureValue.DISABLED:
        return getPromiseWith(false);
      case EFeatureValue.UNSET:
      default:
        return target[name];
    }
  },
});
